import BannerPanel from "./bannerPanel.container";

export default BannerPanel;
